export const environment = {
  ENVIRONMENT: 'production',
  SAAS_SERVICE: 'https://api.trevo-fms.my/saas/v1/web',
};
